// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btndoweload {
    background-color: #F3903F; /* Orange */
    color: white; /* White text */
    font-weight: semibold;
    padding: 5px 5px;
      size: 16px;
      height: 40px;
    border-radius: 8px;
    border: none;
    transition:  0.3s ease, transform 0.2s ease;
  }
  .btn-upload {
    background-color: transparent; /* Transparent background */
    color: #F3903F; /* Orange text */
    font-weight: semibold;
    padding: 5px 5px;
    size: 16px;
    height: 40px;
    border-radius: 8px;
    border: 2px solid #F3903F; /* Orange border */
    transition: 0.3s ease, transform 0.2s ease;
  }

  .btn-upload:hover {
    background-color: #F3903F; /* Orange background on hover */
    color: white; /* White text on hover */
  }
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .table-container {
    width: 100%;
    margin: 0;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .table-title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
  }

  .styled-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    background-color: white;
  }
  
  .styled-table th,
  .styled-table td {
    padding: 12px;
   
    border-bottom: 1px solid #ddd;
  }
  
  .styled-table th {
    background-color: #f2f2f2;
    cursor: pointer;
  }
  
  .styled-table th.sortable-header:hover {
    background-color: #eaeef2;
  }`, "",{"version":3,"sources":["webpack://./src/pages/User/style.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB,EAAE,WAAW;IACtC,YAAY,EAAE,eAAe;IAC7B,qBAAqB;IACrB,gBAAgB;MACd,UAAU;MACV,YAAY;IACd,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;EAC7C;EACA;IACE,6BAA6B,EAAE,2BAA2B;IAC1D,cAAc,EAAE,gBAAgB;IAChC,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB,EAAE,kBAAkB;IAC7C,0CAA0C;EAC5C;;EAEA;IACE,yBAAyB,EAAE,+BAA+B;IAC1D,YAAY,EAAE,wBAAwB;EACxC;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;;IAEb,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".btndoweload {\n    background-color: #F3903F; /* Orange */\n    color: white; /* White text */\n    font-weight: semibold;\n    padding: 5px 5px;\n      size: 16px;\n      height: 40px;\n    border-radius: 8px;\n    border: none;\n    transition:  0.3s ease, transform 0.2s ease;\n  }\n  .btn-upload {\n    background-color: transparent; /* Transparent background */\n    color: #F3903F; /* Orange text */\n    font-weight: semibold;\n    padding: 5px 5px;\n    size: 16px;\n    height: 40px;\n    border-radius: 8px;\n    border: 2px solid #F3903F; /* Orange border */\n    transition: 0.3s ease, transform 0.2s ease;\n  }\n\n  .btn-upload:hover {\n    background-color: #F3903F; /* Orange background on hover */\n    color: white; /* White text on hover */\n  }\n  .table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .table th,\n  .table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: center;\n  }\n  \n  .table tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n  .table-container {\n    width: 100%;\n    margin: 0;\n    padding: 10px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .table-title {\n    text-align: center;\n    margin-bottom: 20px;\n    font-size: 24px;\n    color: #333;\n  }\n\n  .styled-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n    background-color: white;\n  }\n  \n  .styled-table th,\n  .styled-table td {\n    padding: 12px;\n   \n    border-bottom: 1px solid #ddd;\n  }\n  \n  .styled-table th {\n    background-color: #f2f2f2;\n    cursor: pointer;\n  }\n  \n  .styled-table th.sortable-header:hover {\n    background-color: #eaeef2;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
